import { Box } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { IntegrationsJoinMultiPostErrorsDocument } from 'generated/resources/graphql'

import Callout from 'modules/core/components/Callout'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

interface Props {
  atsJobPostingId: number
  locationId?: number
  removable?: boolean
}

export const JobMultiPostErrors = ({
  atsJobPostingId,
  locationId = -1,
  removable = false,
}: Props) => {
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(IntegrationsJoinMultiPostErrorsDocument, {
    variables: {
      companyId: company.id,
      atsJobPostingIds: [atsJobPostingId],
      locationIds: [locationId],
    },
  })
  const localStorageKey = LOCAL_STORAGE_KEYS.integrationsJoinHideJobMultipostingErrorCallout
  const [calloutRead, setCalloutRead] = useLocalStorage<boolean>(localStorageKey)
  const joinJobPosting = data?.integrationsJoin.jobPostingsConnection.nodes[0]
  const joinOffice = data?.integrationsJoin.officesConnection.nodes[0]
  const hasErrors = !!joinJobPosting?.errorCodes || !!joinOffice?.errorLabels
  const hideCallout = removable && calloutRead

  if (loading || !hasErrors || hideCallout) return null

  const errorCodes = [
    ...(joinJobPosting?.errorCodes?.split(',') ?? []),
    ...(joinOffice?.errorLabels?.split(',') ?? []),
  ]

  return (
    <Callout
      title={i18n.t('ats.job_details.job_multipost_errors.callout_title')}
      type="critical"
      onRemove={removable ? () => setCalloutRead(true) : undefined}
    >
      <Box component="ul" paddingX="s24" style={{ listStyleType: 'disc' }}>
        {errorCodes.map((error, index) => (
          <li key={`${index}-${error}`}>{error}</li>
        ))}
      </Box>
    </Callout>
  )
}
